/**
 * hub.coranchers.com API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ShelfLifeBySiteGeoLocationItem { 
    itemNumber?: string | null;
    itemDescription?: string | null;
    uOfM?: string | null;
    customerOrderNumber?: string | null;
    shipDate?: string;
    readonly shipDateDisplay?: string | null;
    expDate?: string;
    readonly expDateDisplay?: string | null;
    expDateState?: string | null;
    pinExpDateStateColor?: string | null;
    quantity?: number;
    readonly quantityDisplay?: string | null;
}

